import React, { FC } from "react"
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary"

type Props = {
  children?: React.ReactNode
}

const ErrorFallback = () => (
  <div role="alert" style={{ padding: 24 }}>
    <p>Something went wrong rendering this page.</p>
    <p>
      Please refresh and try again. If the problem continues, contact support.
    </p>
  </div>
)

const ErrorBoundary: FC<Props> = ({ children }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => {
        // Type only — messages can include client/transcript or SDK details.
        console.error("ErrorBoundary", error?.name ?? "Error")
      }}
    >
      {children}
    </ReactErrorBoundary>
  )
}

export default ErrorBoundary
